enum UnderwriterActionType {
	NONE = 'None',
	APPROVE = 'Approve',
	HOLD = 'Hold',
	DECLINE = 'Decline',
	NO_DECISION = 'NoDecision',
}

export default UnderwriterActionType;